<div *ngFor="let faq of faqs; let i = index">
  <hr class="white-bar" />
  <button
    class="faq-button"
    (click)="openOrClose(i)"
    type="button"
    [attr.data-target]="'#faq-' + i"
    data-toggle="collapse"
    aria-expanded="false"
    aria-controls="collapseExample"
  >
    <span class="faqq">{{ faq.question }}</span>
    <img
      class="{{ faqs[i].faqOpen ? 'close-faq' : 'open-faq' }}"
      src="/assets/img/static-pages/medigi/v2-images/standalone-icons/x.svg"
      alt=""
    />
  </button>

  <div class="collapse" [attr.id]="'faq-' + i">
    <div class="card card-body">
      <p class="faq-answer">{{ faq.answer }}</p>
    </div>
  </div>
</div>

<div *ngFor="let faq of faqs; let i = index"></div>
<hr class="white-bar" />
